import { getTurnoversByCurrentYear } from '../../../utils/functions/history'

export const getCurrentTurnovers = (suppliersId, turnovers, periods) => {
  const filteredTurnovers = turnovers.filter((turnover) => suppliersId.includes(turnover.supplierId))
  return getTurnoversByCurrentYear(filteredTurnovers, periods)
}
